module.exports = __webpack_public_path__ + "media/fr_ca_s3_Raphael.c6af5dce.mp3";